import { configurationContainer } from "@/configurationContainer";

export const getBaseHttpUrl = (): string =>
    configurationContainer.PUBLIC_ODIN_API_URL;
